import BatchList from './batch-list';

export default {
  init: function (selector) {
    const batchLists = document.querySelectorAll(selector);

    if (batchLists && batchLists.length) {
      [...batchLists].map(item => {
        const options = item.getAttribute('data-batch-options') || '{}';
        const batchList = new BatchList(item, JSON.parse(options));
        batchList.init();
      });
    }
  }
};
